<div>
    <button
        mat-raised-button
        class="returnButton"
        color="accent"
        (click)="loadBack()"
    >
        <mat-icon aria-label="Calculate">keyboard_backspace</mat-icon>
        {{ "dashboardBizzDev.returnButton.fullLabel" | translate }}
    </button>
</div>
<mat-card class="error-block">
    <mat-card-header>
        <mat-card-title>
            <h4>
                {{
                    "dashboardBizzDev.details.documentation.title.fullLabel"
                        | translate
                }}
            </h4>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <table>
            <thead>
                <tr>
                    <th>
                        {{
                            "dashboardBizzDev.details.documentation.table.header.rowOne.fullLabel"
                                | translate
                        }}
                    </th>
                    <th>
                        {{
                            "dashboardBizzDev.details.documentation.table.header.rowTwo.fullLabel"
                                | translate
                        }}
                    </th>
                    <th>
                        {{
                            "dashboardBizzDev.details.documentation.table.header.rowThree.fullLabel"
                                | translate
                        }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.unknown.shortLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.unknown.fullLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.unknown.detail"
                                | translate
                        }}
                    </td>
                </tr>
                <tr>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.badRequest.shortLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.badRequest.fullLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.badRequest.detail"
                                | translate
                        }}
                    </td>
                </tr>
                <tr>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.unauthorized.shortLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.unauthorized.fullLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.unauthorized.detail"
                                | translate
                        }}
                    </td>
                </tr>
                <tr>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.forbidden.shortLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.forbidden.fullLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.forbidden.detail"
                                | translate
                        }}
                    </td>
                </tr>
                <tr>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.notFound.shortLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.notFound.fullLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.notFound.detail"
                                | translate
                        }}
                    </td>
                </tr>
                <tr>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.internalServerError.shortLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.internalServerError.fullLabel"
                                | translate
                        }}
                    </td>
                    <td>
                        {{
                            "dashboardBizzDev.details.documentation.table.body.internalServerError.detail"
                                | translate
                        }}
                    </td>
                </tr>
            </tbody>
        </table>
    </mat-card-content>
</mat-card>
